import { pupUniDriver } from '@wix/unidriver-puppeteer';
import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '../base-driver';

interface DriverFactoryOptions {
  dataHook: string;
}

/** @DEPRECATED please use `puppeteerUniTestkitFactoryCreator` */
export function puppeteerTestkitFactoryCreator<T>(
  driverFactory: (e: any, page: any, options: DriverFactoryOptions) => T,
) {
  return async (obj: { dataHook: string; page: any }) =>
    driverFactory(await obj.page.$(`[data-hook='${obj.dataHook}']`), obj.page, {
      dataHook: obj.dataHook,
    });
}

export function puppeteerUniTestkitFactoryCreator<T extends BaseUniDriver>(
  driverFactory: (
    base: UniDriver,
    body: UniDriver,
    options: DriverFactoryOptions,
  ) => T,
) {
  return async (obj: { dataHook: string; page: any; wrapper?: any }) => {
    const { dataHook, wrapper: element, page } = obj; // destructuring `wrapper` so that type inference works well
    const selector = `[data-hook='${dataHook}']`;

    const base = element
      ? pupUniDriver(async () => ({
          element: await element.$(selector),
          page,
          selector,
        }))
      : pupUniDriver({ page, selector });

    const body = pupUniDriver({ page, selector: 'body' });
    return driverFactory(base, body, { dataHook });
  };
}
